import React, { useEffect, useState } from "react";
import Footer from "../../components/footer";
import { getSection1 } from "../../api/testimonialsPage/section1";
//import Carousel from "../../components/carousel";
import { getSection2 } from "../../api/testimonialsPage/section2";
import { Button } from "../../components/ui/button";
import { NavLink } from "react-router-dom";
import { Icons } from "../../assets/icons";
import { getSection3 } from "../../api/testimonialsPage/section3";
import FeaturedTestimonial from "./FeaturedTestimonial";
import TestimonialsGrid from "./TestimonialGrid";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const TestimonialsPage = () => {
  useDocumentTitle("Testimonials");

  const [loading1, setLoading1] = useState(true);
  // const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);

  const [data1, setData1] = useState<any>();
  // const [data2, setData2] = useState<any>();
  const [data3, setData3] = useState<any>();
  const [error3, setError3] = useState<string | null>(null);

  const fetchData = () => {
    getSection1().then((res) => {
      setData1(res.data);
      setLoading1(false);
    });
    // getSection2().then((res) => {
    //   setData2(res.data);
    //   setLoading2(false);
    // });
    getSection3()
      .then((res) => {
        setData3(res);
        setLoading3(false);
        setError3(null);
      })
      .catch((error) => {
        setError3("Failed to fetch testimonials");
        setLoading3(false);
      });
    //  getSection4().then((res) => {
    //      setData4(res.data);
    //      setLoading4(false);
    //  });
    //  getSection5().then((res) => {
    //      setData5(res.data);
    //      setLoading5(false);
    //  });
  };
  // const createSlides = (comments: any[]) => {
  //   return comments.map((comment) => (
  //     <div className="grid md:grid-cols-2 grid-cols-1 gap-12 text-left">
  //       <div className="md:text-2xl text-xl md:leading-7 leading-6">
  //         {comment.Comment1}
  //       </div>
  //       <div className="md:text-2xl text-xl md:leading-7 leading-6">
  //         {comment.Comment2}
  //       </div>
  //       <div>
  //         <div className="flex gap-4 items-center mt-4">
  //           <img
  //             src={`${process.env.REACT_APP_API_BASE_URL}${comment.Image.url}`}
  //             alt={comment.Image.alternativeText}
  //             className="h-20 w-20 rounded-full"
  //           />

  //           <div className="">
  //             <div className="text-lg font-bold">{comment.Name}</div>
  //             <div className="text-body-text-gray8 font-normal text-base">
  //               {comment.Designation}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ));
  // };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="md:pt-12 pt-4">
        {!loading1 && (
          <section className="">
            <div className="grid md:grid-cols-2 md:gap-12 gap-8 items-center md:px-12 px-4">
              <div className="md:hidden">
                <div className="relative h-full w-full ">
                  <img
                    className="rounded-[8px]"
                    src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image.url}`}
                    alt={data1.Image.alternativeText}
                  />
                  <div className="absolute top-0 left-0 p-4 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                    <div className="text-body-text-lilly_red">
                      <img
                        className="h-10 w-10 object-cover"
                        src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                        alt={
                          data1?.Icon?.alternativeText ??
                          "testimonial page icon"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h1>
                  <div className="md:text-5xl text-3xl tracking-tighter leading-8 font-medium">
                    {data1.Header}
                  </div>
                </h1>
                <div className="my-4 max-w-[40rem]">{data1.Description}</div>
                <div className="my-4 max-w-[40rem] mt-4">
                  {data1.Description2}
                </div>
              </div>
              <div className="relative hidden md:block h-full ">
                <img
                  className="h-full w-full object-cover rounded-[6px]"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image.url}`}
                  alt={data1.Image.alternativeText}
                />

                <div className="absolute right-full h-20 w-20 p-5 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                  <div className="text-body-text-lilly_red">
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                      alt={
                        data1?.Icon?.alternativeText ?? "testimonial page icon"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="md:hidden my-8">
              {!loading2 && (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}${data2.Image.url}`}
                  alt={data2.Image.alternativeText}
                  className="w-full h-full"
                />
              )}
            </div> */}
          </section>
        )}
        {/* {!loading2 && (
          <section className="md:px-12 px-4 md:mt-48 py-16 md:py-0">
            <div className="grid grid-cols-4 gap-12 items-center">
              <div className="w-full h-full md:block hidden">
                <img
                  className="h-full w-full object-cover"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data2.Image.url}`}
                  alt={data2.Image.alternativeText}
                />
              </div>
              <div className="md:col-span-3 col-span-4">
                <div className="text-2xl font-bold">
                  {data2.Header}&nbsp;
                  <span className="font-normal">
                    |&nbsp;
                    {data2.Header2}
                  </span>
                </div>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-8 mt-8">
                  <div>
                    <div className="md:text-2xl text-xl md:leading-8 leading-7">
                      {data2.Comment}
                    </div>
                    <div className="text-base mt-8">
                      <div className="font-bold">{data2.Name}</div>
                      <div>{data2.Designation}</div>
                    </div>
                  </div>
                  <div>
                    <div>{data2.Description}</div>
                    <Button variant="outline" className="w-full md:w-fit mt-8">
                      <NavLink
                        to={data2.Button_link}
                        className="flex gap-2 w-full items-center justify-between md:justify-center"
                        target="_blank"
                      >
                        {data2.Button_text}
                        <Icons.ChevronRight />
                      </NavLink>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )} */}
        {!loading3 && data3?.data && (
          <section className="md:mt-32 mt-20 mb-0">
            <div className="md:px-12 px-4 py-20 mt:20 md:py-16">
              {data3.data.Featured && (
                <FeaturedTestimonial
                  comment={data3.data.Featured}
                  headerBold={data3.data.Featured.Header}
                  headerNormal={data3.data.Featured.BiotechName}
                />
              )}

              {data3.data.Comments && (
                <TestimonialsGrid comments={data3.data.Comments} />
              )}
            </div>
          </section>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TestimonialsPage;
